const topicItems = [
  { tag: '#顶流恋情曝光', count: '128.5万讨论', hot: true },
  { tag: '#直播带货翻车', count: '96.2万讨论', hot: true },
  { tag: '#剧组潜规则', count: '87.3万讨论', hot: true },
  { tag: '#品牌集体解约', count: '74.8万讨论', hot: false },
  { tag: '#综艺剪辑争议', count: '63.1万讨论', hot: false },
  { tag: '#网红情侣互撕', count: '55.6万讨论', hot: false },
  { tag: '#社交平台删帖', count: '48.9万讨论', hot: false },
  { tag: '#明星穿搭翻车', count: '42.3万讨论', hot: false },
  { tag: '#电竞转会内幕', count: '36.7万讨论', hot: false },
  { tag: '#吃瓜每日精选', count: '31.2万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-hashtag text-accent-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          热门话题标签
        </h2>
        <p className="text-sm text-foreground-500 mb-8">全网最新吃瓜话题，点击直达51吃瓜网今日吃瓜话题广场</p>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item, i) => (
            <a
              key={i}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/60 text-foreground-600 hover:border-primary-200 hover:text-primary-500'
              }`}
            >
              <span className="text-sm font-medium">{item.tag}</span>
              <span className="text-xs opacity-70">{item.count}</span>
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}